"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcListRowBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_list_row_constants_1 = require("./bc-list-row-constants");
var bc_tooltip_behavior_1 = require("../bc-tooltip/bc-tooltip-behavior");
var bc_float_menu_behavior_1 = require("../../organisms/bc-float-menu/bc-float-menu-behavior");
var BcListRowBehavior = (function (_super) {
    __extends(BcListRowBehavior, _super);
    function BcListRowBehavior() {
        var _this = _super.call(this) || this;
        _this.tagClass = "".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_ORDER, "-").concat(bc_list_row_constants_1.BcListRowConstants.TAG_TAG);
        _this.orderClass = "".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_ORDER);
        return _this;
    }
    BcListRowBehavior.setUpAll = function () {
        var listRowParentElements = Array.from(document.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_TABLE)));
        var elements = [];
        for (var _i = 0, listRowParentElements_1 = listRowParentElements; _i < listRowParentElements_1.length; _i++) {
            var listRowParentElement = listRowParentElements_1[_i];
            var listRowInstance = new BcListRowBehavior();
            listRowInstance.setElement(listRowParentElement);
            listRowInstance.setUp();
            elements.push(listRowInstance);
        }
        return elements;
    };
    BcListRowBehavior.prototype._setUp = function () {
        this.getElements();
        this.setCheckbox();
        this.setRadioButton();
        this.setAccesibility();
        this.setTooltipTexts();
        this.addingPrimaryColumns();
        this.windowsResizeEvent();
        this.mobileResponsive();
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
        bc_float_menu_behavior_1.BcFloatMenuBehavior.setUpAll();
    };
    BcListRowBehavior.prototype.getElements = function () {
        this.rows = Array.from(this.mySelf.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_ROW)));
    };
    BcListRowBehavior.prototype.setCheckbox = function () {
        this.rows.forEach(function (row) {
            var checkbox = row.querySelector(bc_list_row_constants_1.BcListRowQuerySelectors.INPUT_TYPE_CHECKBOX);
            checkbox === null || checkbox === void 0 ? void 0 : checkbox.addEventListener(bc_list_row_constants_1.BcListRowConstants.EVENT_CHANGE, function () {
                this.checked ? row.classList.add(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED) : row.classList.remove(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED);
            });
            if (checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) {
                row.classList.add(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED);
            }
        });
    };
    BcListRowBehavior.prototype.setRadioButton = function () {
        this.rows.forEach(function (row) {
            var radioButton = row.querySelector(bc_list_row_constants_1.BcListRowQuerySelectors.INPUT_TYPE_RADIO);
            radioButton === null || radioButton === void 0 ? void 0 : radioButton.addEventListener(bc_list_row_constants_1.BcListRowConstants.EVENT_CHANGE, function () {
                var rowSelected = document.querySelector("tr.".concat(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED));
                rowSelected === null || rowSelected === void 0 ? void 0 : rowSelected.classList.remove(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED);
                this.checked && row.classList.add(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED);
            });
        });
    };
    BcListRowBehavior.prototype.setAccesibility = function () {
        var _this = this;
        var bcListRowElements = Array.from(this.mySelf.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_ROW)));
        bcListRowElements.forEach(function (row) {
            _this.setElementAttributes(row);
            _this.setListenerForActionableKeys(row);
        });
    };
    BcListRowBehavior.prototype.setTooltipTexts = function () {
        var bcListTexts = this.mySelf.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT_DATA_TEXT_SHRINKABLE));
        bcListTexts.forEach(function (bcListText) {
            if (bcListText.offsetWidth < bcListText.scrollWidth) {
                bcListText.classList.add(bc_list_row_constants_1.BcListRowConstants.BC_TOOLTIP_CLASS);
                bcListText.setAttribute(bc_list_row_constants_1.BcListRowConstants.BC_TOOLTIP_TEXT, bcListText.innerHTML);
                bcListText.removeAttribute(bc_list_row_constants_1.BcListRowConstants.TABINDEX);
            }
        });
    };
    BcListRowBehavior.prototype.addingPrimaryColumns = function () {
        var _this = this;
        this.rows.forEach(function (row) {
            _this.setPrimaryColumns(row);
            _this.hideExtraColumns(row);
        });
    };
    BcListRowBehavior.prototype.setPrimaryColumns = function (row) {
        var contentColumns = Array.from(row.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT)));
        var contentColumnIndexes = [];
        contentColumns.forEach(function (contentColumn, index) {
            contentColumn.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY) && contentColumnIndexes.push(index);
        });
        if (contentColumnIndexes.length === 0) {
            contentColumnIndexes = this.getDefaultPrimaryIndexes(contentColumns);
            this.addPrimaryClassForResponsive(row, contentColumnIndexes);
        }
    };
    BcListRowBehavior.prototype.windowsResizeEvent = function () {
        var _this = this;
        var events = [
            bc_list_row_constants_1.BcListRowConstants.EVENT_RESIZE,
            bc_list_row_constants_1.BcListRowConstants.EVENT_KEY_UP,
            bc_list_row_constants_1.BcListRowConstants.EVENT_CLICK
        ];
        var handleResizeEvent = function () {
            _this.mobileResponsive();
        };
        events.forEach(function (event) {
            window.addEventListener(event, handleResizeEvent);
        });
    };
    BcListRowBehavior.prototype.mobileResponsive = function () {
        var _this = this;
        this.getElements();
        this.rows.forEach(function (row) {
            window.innerWidth <= Number(bc_list_row_constants_1.BcListRowConstants.TABLE_SMALL_BREAK_POINT)
                ? _this.addPrimaryOrderIndex(row)
                : _this.removeMobileClasses(row);
        });
    };
    BcListRowBehavior.prototype.getDefaultPrimaryIndexes = function (contentColumns) {
        var lengthOfContentColumnsShowed = contentColumns.length > bc_list_row_constants_1.BcListRowConstants.LIST_ROW_MAX_NUMBER ? bc_list_row_constants_1.BcListRowConstants.LIST_ROW_MAX_NUMBER : contentColumns.length;
        var listOfTheLastContentColumnsIndexes = Array.from({ length: lengthOfContentColumnsShowed }, function (_, index) { return index; }).slice(-bc_list_row_constants_1.BcListRowConstants.LIST_ROW_LAST_ITEMS);
        var firstRowElementIndex = 0;
        return __spreadArray([firstRowElementIndex], listOfTheLastContentColumnsIndexes, true);
    };
    BcListRowBehavior.prototype.hideExtraColumns = function (row) {
        var columns = Array.from(row.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT)));
        var numberOfExtraColumns = columns.length - bc_list_row_constants_1.BcListRowConstants.LIST_ROW_MAX_NUMBER;
        var extraColumns = numberOfExtraColumns > 0 ? columns.slice(-numberOfExtraColumns) : [];
        extraColumns.forEach(function (extraColumn) {
            extraColumn.classList.add(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_HIDE_EXTRA_COLUMN);
        });
    };
    BcListRowBehavior.prototype.addPrimaryClassForResponsive = function (row, primaryColumnIndexes) {
        var columnContents = Array.from(row.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT)));
        for (var _i = 0, primaryColumnIndexes_1 = primaryColumnIndexes; _i < primaryColumnIndexes_1.length; _i++) {
            var primaryColumnIndex = primaryColumnIndexes_1[_i];
            columnContents[primaryColumnIndex].classList.add(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY);
        }
    };
    BcListRowBehavior.prototype.addPrimaryOrderIndex = function (row) {
        var _this = this;
        if (!row.style.height) {
            var _a = this.getComputedValues(row), paddingBottom_1 = _a.paddingBottom, height = _a.height;
            var primaries_1 = row.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY));
            primaries_1.forEach(function (primary, index) {
                var setIndex = index + 1;
                (primaries_1.length === bc_list_row_constants_1.BcListRowConstants.TWO_PRIMARY_ELEMENTS && index === bc_list_row_constants_1.BcListRowConstants.FIRST_POSITION) && setIndex++;
                primary.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_LEFT_MOBILE_POSITION) ?
                    primary.classList.add(_this.tagClass) : primary.classList.add("".concat(_this.orderClass, "-").concat(setIndex));
                primary.style.bottom = "".concat(paddingBottom_1, "px");
            });
            if (primaries_1.length > 1 && !row.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_ROW_TITLE)) {
                row.style.height = "".concat((height * bc_list_row_constants_1.BcListRowConstants.DOUBLE) + bc_list_row_constants_1.BcListRowConstants.LIST_ROW_SEPARATION_MOBILE + paddingBottom_1, "px");
            }
        }
    };
    BcListRowBehavior.prototype.removeMobileClasses = function (row) {
        var _this = this;
        if (row.style.height) {
            row.style.removeProperty(bc_list_row_constants_1.BcListRowConstants.HEIGHT);
            var primaries = row.querySelectorAll(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY));
            primaries.forEach(function (primary, index) {
                primary.style.removeProperty(bc_list_row_constants_1.BcListRowConstants.BOTTOM);
                primary.classList.remove("".concat(_this.orderClass, "-").concat(index + 1));
            });
        }
    };
    BcListRowBehavior.prototype.getComputedValues = function (element) {
        var computedStyle = getComputedStyle(element);
        var height = element.offsetHeight;
        return {
            paddingTop: parseFloat(computedStyle.paddingTop),
            paddingBottom: parseFloat(computedStyle.paddingBottom),
            height: height - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom)
        };
    };
    BcListRowBehavior.prototype.setListenerForActionableKeys = function (element) {
        var actionColumn = element.querySelector(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_ACTION));
        var columnMenu = element.querySelector(".".concat(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_MENU));
        if (actionColumn) {
            actionColumn.addEventListener(bc_list_row_constants_1.BcListRowConstants.EVENT_KEY_DOWN, function (event) {
                if (event.code === bc_list_row_constants_1.BcListRowConstants.KEY_EVENT_SPACE || event.code === bc_list_row_constants_1.BcListRowConstants.KEY_EVENT_ENTER) {
                    event.preventDefault();
                    event.target.click();
                }
            });
        }
        if (columnMenu) {
            columnMenu.addEventListener(bc_list_row_constants_1.BcListRowConstants.EVENT_KEY_DOWN, function (event) {
                if (event.code === bc_list_row_constants_1.BcListRowConstants.KEY_EVENT_SPACE || event.code === bc_list_row_constants_1.BcListRowConstants.KEY_EVENT_ENTER) {
                    event.preventDefault();
                    event.target.click();
                }
            });
        }
    };
    BcListRowBehavior.prototype.setElementAttributes = function (element) {
        element.setAttribute(bc_list_row_constants_1.BcListRowConstants.TABINDEX, "".concat(bc_list_row_constants_1.BcListRowConstants.ZERO));
        element.setAttribute(bc_list_row_constants_1.BcListRowConstants.ROLE, bc_list_row_constants_1.BcListRowAriaLabels.FOR_BUTTON);
        element.setAttribute(bc_list_row_constants_1.BcListRowConstants.ARIA_LABEL, bc_list_row_constants_1.BcListRowAriaLabels.MAIN_ACTION);
        var childrenElements = Array.from(element.children);
        if (element.children.length > 0) {
            childrenElements.forEach(function (child, index) {
                child.setAttribute(bc_list_row_constants_1.BcListRowConstants.ROLE, bc_list_row_constants_1.BcListRowAriaLabels.FOR_CELL);
                child.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_CONTENT) && child.setAttribute(bc_list_row_constants_1.BcListRowConstants.ARIA_LABEL, "".concat(bc_list_row_constants_1.BcListRowAriaLabels.DATA_COLUMN, " ").concat(index));
                child.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_ACTION) && child.setAttribute(bc_list_row_constants_1.BcListRowConstants.ARIA_LABEL, "".concat(bc_list_row_constants_1.BcListRowAriaLabels.CHECKBOX));
                child.classList.contains(bc_list_row_constants_1.BcListRowConstants.LIST_COLUMN_MENU) && child.setAttribute(bc_list_row_constants_1.BcListRowConstants.ARIA_LABEL, "".concat(bc_list_row_constants_1.BcListRowAriaLabels.ROW_OPTIONS));
            });
        }
    };
    return BcListRowBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcListRowBehavior = BcListRowBehavior;
